import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Message = styled.p`
  margin: 0 0 16px 0;
  color: #6C727F;
  font-size: 15px;
`;
